import { chain, SetFilterQuery } from "@insite/client-framework/Store/Pages/ProductList/Handlers/SetFilterQuery";
import cloneDeep from "lodash/cloneDeep";
import { HandlerWithResult, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { isLoadMore } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import qs from "qs";
import { Dictionary } from "@insite/client-framework/Common/Types";

const knownFilterKeys = new Set([
    "criteria",
    // HasPagingParameters
    "page",
    "pageSize",
    "defaultPageSize",
    "sort",
    // ProductFilters
    "pageCategoryId",
    "pageBrandId",
    "pageProductLineId",
    "query",
    "includeSuggestions",
    "stockedItemsOnly",
    "previouslyPurchasedProducts",
    "searchWithinQueries",
    "brandIds",
    "productLineIds",
    "priceFilters",
    "attributeValueIds",
    "categoryId",
    "expand",
    "additionalExpands",
    "minimumPrice", // Added minimumPrice to knownFilterKeys to ensure it is included in the query string when set
]);

type HandlerType = HandlerWithResult<{}, string>;

export const CustomSetFilterQuery: HandlerType = props => {
    const queryObject = cloneDeep(props.getState().pages.productList.productFilters);
    delete queryObject.expand;
    delete queryObject.pageCategoryId;
    delete queryObject.pageProductLineId;
    delete queryObject.pageBrandId;

    if (isLoadMore(props.getState())) {
        delete queryObject.pageSize;
    }

    if (queryObject.searchWithinQueries && queryObject.searchWithinQueries.length > 1) {
        // Search within Queries need to split by space, to use for ElasticSearch
        queryObject.searchWithinQueries = [queryObject.searchWithinQueries.join(" ")];
    }

    const currentSearch = typeof window !== "undefined" ? window.location.search : "";
    const currentParams = qs.parse(currentSearch, { ignoreQueryPrefix: true });
    const thirdPartyParams: Dictionary<unknown> = {};
    for (const key of Object.keys(currentParams)) {
        if (!knownFilterKeys.has(key)) {
            thirdPartyParams[key] = currentParams[key];
        }
    }

    const mergedQuery = { ...queryObject, ...thirdPartyParams };
    props.result = qs.stringify(mergedQuery, { arrayFormat: "comma", skipNulls: true });
};

replaceInChain(chain, SetFilterQuery, CustomSetFilterQuery);
